export function getRTMIDBYRTC(rtcId: string) {
  const user = JSON.parse(rtcId);
  return user.name + "_" + user.is_admin;
}
export function getDetailsFromRTMID(rtm_id: string) {
  const [user_name, is_admin] = rtm_id.split("_");
  return [user_name, is_admin === "true" ? true : false];
}
